export function cn(...classes: any[]) {
  return classes.filter(Boolean).join(" ");
}

/**
 * Resolve an asset URL that may be either absolute (already a full CDN URL)
 * or relative (e.g. "/uploads/thumbnails/logo.png" from the header-footer
 * config), prefixing relative paths with the media CDN base URL.
 */
export function resolveAssetUrl(url: string): string {
  if (!url) return url;
  if (/^https?:\/\//i.test(url)) return url;
  const base = process.env.NEXT_PUBLIC_MEDIA_BASE_URL || "https://media.dinamani.com";
  return `${base}${url.startsWith("/") ? "" : "/"}${url}`;
}
